"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = {
    key: 0,
    class: "font-bold text-[20px] mb-3 uppercase"
};
const _hoisted_3 = {
    key: 1,
    class: "mb-5"
};
const _hoisted_4 = { class: "font-bold text-[20px] mb-3 uppercase" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "border-b-2 my-5 border-[#929292]"
};
const _hoisted_7 = {
    key: 2,
    class: "font-bold text-[20px] mb-3 uppercase"
};
const _hoisted_8 = {
    key: 3,
    class: "mb-3"
};
const _hoisted_9 = {
    key: 1,
    class: "flex mb-3"
};
const _hoisted_10 = { class: "text-right" };
const _hoisted_11 = ["disabled"];
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const i18n_1 = require("../../common/i18n");
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const CreateOrderRequest_1 = __importDefault(require("../../stores/checkout/CreateOrderRequest"));
const vue_3 = require("vue");
const ShippingModeEnum_1 = require("../../stores/checkout/ShippingModeEnum");
const LocationSelector_vue_1 = __importDefault(require("../../components/Location/LocationSelector.vue"));
const validators_1 = require("../../common/utils/validators");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const checkoutStore_1 = require("../../stores/checkout/checkoutStore");
const vue_router_1 = require("vue-router");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const countryCodeStore_1 = require("../../stores/countryCode/countryCodeStore");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const customersStore_1 = require("../../stores/customers/customersStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShippingAddress',
    props: {
        orderRequest: {
            type: CreateOrderRequest_1.default,
        },
        id: {
            type: String,
            default: () => { var _a; return `shipping-address-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const checkoutStore = (0, checkoutStore_1.useCheckoutStore)();
        const router = (0, vue_router_1.useRouter)();
        const countryCodeStore = (0, countryCodeStore_1.useCountryCodeStore)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        const defaultAddressId = (0, vue_3.ref)((_b = (_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.defaultAddressId) !== null && _b !== void 0 ? _b : 0);
        const currentCountryCode = ShopConfig_1.ShopConfig.getShopLocation2IsoCode();
        const zipCodeLength = (0, vue_3.ref)(countryCodeStore.getCountryZipCodeLength(currentCountryCode));
        const onlyNumeric = (0, vue_3.ref)(countryCodeStore.getOnlyNumeric(currentCountryCode));
        const needRemoteApi = () => {
            var _a;
            return !!((_a = ShopConfig_1.ShopConfig.getLocationApiConnection()) === null || _a === void 0 ? void 0 : _a.url);
        };
        const zipCharsValid = (0, vue_3.ref)(false);
        const handleZipValidation = (isValid) => {
            zipCharsValid.value = isValid;
        };
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const personalPickupPointAddress = (0, vue_3.computed)(() => checkoutStore.shippingAddresses.personalPickupPointAddress);
        const pickupPointAddressesOptions = (0, vue_3.computed)(() => checkoutStore.pickupPointAddressesOptions);
        const customAddressAllowed = (0, vue_3.computed)(() => checkoutStore.shippingAddresses.customAddressAllowed);
        const customerAddressesOptions = (0, vue_3.computed)(() => {
            var _a, _b;
            if (!customAddressAllowed.value) {
                return checkoutStore.customerAddressesOptions;
            }
            if (!((_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingModeId)) {
                return checkoutStore.customerAddressesOptions;
            }
            if (ShippingModeEnum_1.ShippingModeEnum.EXPRESS == props.orderRequest.shippingModeId) {
                return checkoutStore.customerAddressesOptions;
            }
            return [
                ...checkoutStore.customerAddressesOptions,
                new Option_1.default("custom", (_b = (0, i18n_1.trans)("custom_address_option", "Custom address", "checkout")) !== null && _b !== void 0 ? _b : "Custom address", false),
            ];
        });
        const glsFlexDeliveryFormSubmitted = (0, vue_3.computed)(() => checkoutStore.glsFlexDeliveryFormSubmitted);
        const submitCustomAddressForm = () => checkoutStore.setCustomAddressFormSubmitted(true);
        const customAddressFormValid = (0, vue_3.computed)(() => {
            if (props.orderRequest === undefined) {
                return false;
            }
            if (props.orderRequest.shippingModeId !== null &&
                [
                    ShippingModeEnum_1.ShippingModeEnum.COURIER,
                    ShippingModeEnum_1.ShippingModeEnum.EXPRESS,
                    ShippingModeEnum_1.ShippingModeEnum.GLS_FLEX_DELIVERY,
                ].includes(props.orderRequest.shippingModeId) &&
                props.orderRequest.shippingCustomerAddressId === "custom" &&
                (props.orderRequest.shippingCustomAddressName === null ||
                    props.orderRequest.shippingCustomAddressName === "" ||
                    props.orderRequest.shippingCustomAddressZipCode === null ||
                    props.orderRequest.shippingCustomAddressZipCode === "" ||
                    props.orderRequest.shippingCustomAddressCity === null ||
                    props.orderRequest.shippingCustomAddressCity === "" ||
                    props.orderRequest.shippingCustomAddressStreet === null ||
                    props.orderRequest.shippingCustomAddressStreet === "")) {
                return false;
            }
            return true;
        });
        (0, vue_3.watchEffect)(() => {
            var _a;
            if (activeCart.value !== undefined) {
                checkoutStore
                    .getShippingAddresses(router, {
                    cartId: (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.id,
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
        });
        (0, vue_3.watch)(() => { var _a; return (_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingCustomerAddressId; }, (value, oldValue) => {
            if (props.orderRequest === undefined) {
                return;
            }
            props.orderRequest.shippingCustomAddressName = null;
            props.orderRequest.shippingCustomAddressZipCode = null;
            props.orderRequest.shippingCustomAddressCity = null;
            props.orderRequest.shippingCustomAddressStreet = null;
            props.orderRequest.shippingCustomAddressPhone = null;
            props.orderRequest.paymentModeId = null;
            const requestData = {
                cartId: activeCart.value.id,
                shippingId: props.orderRequest.shippingModeId || '',
                cartCurrency: activeCart.value.getCurrencyCode() || '',
            };
            if ((value === "custom" && oldValue === null) || (value === "custom" && oldValue !== "custom")) {
                requestData.customAddress = true;
            }
            checkoutStore.getPaymentModes(router, requestData)
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
            checkoutStore.resetExtraFees();
            return;
        });
        (0, vue_3.watch)(() => { var _a; return (_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingPickupPointId; }, (value, oldValue) => {
            if (props.orderRequest === undefined) {
                return;
            }
            if (oldValue === null) {
                checkoutStore
                    .getPaymentModes(router, {
                    cartId: activeCart.value.id,
                    shippingId: props.orderRequest.shippingModeId || '',
                    cartCurrency: activeCart.value.getCurrencyCode() || '',
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
                return;
            }
        });
        const shippingCustomAddressZipCodeChanged = (zipCode) => {
            if (props.orderRequest === undefined) {
                return;
            }
            props.orderRequest.shippingCustomAddressZipCode = zipCode;
        };
        const shippingCustomAddressCityChanged = (city) => {
            if (props.orderRequest === undefined) {
                return;
            }
            props.orderRequest.shippingCustomAddressCity = city;
        };
        (0, vue_3.watch)(() => { var _a; return (_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingModeId; }, async () => {
            var _a;
            let foundMatchingAddress = false;
            if (securityStore.authenticatedUser === null) {
                return;
            }
            //Csak akkor állítsa be a shippingCustomerAddressId-t, ha postai vagy GLS szállítást választunk ki
            if (((_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingModeId) &&
                [ShippingModeEnum_1.ShippingModeEnum.COURIER, ShippingModeEnum_1.ShippingModeEnum.GLS_FLEX_DELIVERY, ShippingModeEnum_1.ShippingModeEnum.BEX].includes(props.orderRequest.shippingModeId)) {
                try {
                    const customer = await customersStore.getCustomer(router, securityStore.authenticatedUser.customer.id);
                    if (customer["@type"] !== "Customer") {
                        return;
                    }
                    // Ha a user-en van defaultAddress akkor allitsa be alapertelmezetten.
                    if (defaultAddressId.value) {
                        if (props.orderRequest) {
                            const defaultOption = customerAddressesOptions.value.find((option) => option.value === defaultAddressId.value);
                            if (defaultOption) {
                                defaultOption.selected = true;
                            }
                            // eslint-disable-next-line vue/no-mutating-props
                            props.orderRequest.shippingCustomerAddressId = defaultAddressId.value;
                        }
                        // Ha nincs defaultAddress akkor customer-bol allitsa be.
                    }
                    else {
                        customer.addresses.forEach((customerAddress) => {
                            customerAddressesOptions.value.forEach((option) => {
                                // Ha van default.
                                if (props.orderRequest &&
                                    customerAddress.isDefault &&
                                    customerAddress.id === option.value &&
                                    customer.addresses.length > 0) {
                                    foundMatchingAddress = true;
                                    option.selected = true;
                                    // eslint-disable-next-line vue/no-mutating-props
                                    props.orderRequest.shippingCustomerAddressId =
                                        parseInt(option.value);
                                }
                            });
                        });
                        // Ha nincs akkor az elsot.
                        if (!foundMatchingAddress && props.orderRequest && customer.addresses.length > 0) {
                            customer.addresses.sort((a, b) => a.addressNumber - b.addressNumber);
                            const firstAddress = customerAddressesOptions.value.find((option) => option.value === customer.addresses[0].id);
                            if (firstAddress) {
                                firstAddress.selected = true;
                                const selectedValue = typeof firstAddress.value === "string"
                                    ? parseInt(firstAddress.value)
                                    : firstAddress.value;
                                // eslint-disable-next-line vue/no-mutating-props
                                props.orderRequest.shippingCustomerAddressId =
                                    selectedValue;
                            }
                        }
                    }
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        }, { immediate: true });
        (0, vue_3.onBeforeMount)(() => {
            countryCodeStore.getCountryCodes(router).then(() => {
                zipCodeLength.value = countryCodeStore.getCountryZipCodeLength(currentCountryCode);
                onlyNumeric.value = countryCodeStore.getOnlyNumeric(currentCountryCode);
            });
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (__props.orderRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 0,
                    id: __props.id,
                    class: "mb-3 border-b-2 border-[#929292]"
                }, [
                    (__props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL_AT_PICKUP_POINT
                        && __props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("second_step_shipping_address", "2. step - Shipping address", "checkout")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (((__props.orderRequest.shippingModeId === (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL_AT_PICKUP_POINT
                        || __props.orderRequest.shippingModeId === (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL)
                        && (0, vue_2.unref)(personalPickupPointAddress) !== null))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pick_up_point", "2. step - Pick up point", "checkout")), 1),
                            (__props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL_AT_PICKUP_POINT)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)((_a = (0, vue_2.unref)(personalPickupPointAddress)) === null || _a === void 0 ? void 0 : _a.name), 1))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL_AT_PICKUP_POINT
                                && __props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL_AT_PICKUP_POINT
                                && __props.orderRequest.shippingModeId !== (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("second_step_shipping_address", "3. step - Shipping address", "checkout")), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (__props.orderRequest.shippingModeId !== null &&
                        ([(0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).EXPRESS, (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).COURIER, (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).TRUCK_TRANSPORT, (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).BEX].includes(__props.orderRequest.shippingModeId) ||
                            ((0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).GLS_FLEX_DELIVERY ===
                                __props.orderRequest.shippingModeId &&
                                (0, vue_2.unref)(glsFlexDeliveryFormSubmitted))))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SelectInput_vue_1.default, {
                            key: 2,
                            id: "shipping-address-select-input",
                            "placeholder-enable": true,
                            class: "mb-5",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('address_placeholder', '-- Please select an address --', 'checkout'),
                            modelValue: __props.orderRequest.shippingCustomerAddressId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.orderRequest.shippingCustomerAddressId) = $event)),
                            options: (0, vue_2.unref)(customerAddressesOptions)
                        }, null, 8, ["placeholder", "modelValue", "options"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (__props.orderRequest.shippingModeId !== null &&
                        ([
                            (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).GLS_FLEX_DELIVERY,
                            (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).COURIER,
                            (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).TRUCK_TRANSPORT,
                            (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).BEX,
                        ].includes(__props.orderRequest.shippingModeId)
                            || [(0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL].includes(__props.orderRequest.shippingModeId)
                                && ((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).ALLOW_USER_TRANSFER)))
                        && (0, vue_2.unref)(customAddressAllowed) &&
                        __props.orderRequest.shippingCustomerAddressId === 'custom')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                id: "shipping-address-custom-name-input",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_name', 'Name', 'checkout'),
                                modelValue: __props.orderRequest.shippingCustomAddressName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.orderRequest.shippingCustomAddressName) = $event)),
                                class: "mb-3",
                                type: "text",
                                border: "",
                                "disable-focus-ring": "",
                                required: "",
                                "show-validity": true,
                                valid: !(0, vue_2.unref)(validators_1.isBlank)(__props.orderRequest.shippingCustomAddressName)
                            }, null, 8, ["placeholder", "modelValue", "valid"]),
                            (needRemoteApi())
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(LocationSelector_vue_1.default, {
                                    key: 0,
                                    id: "shipping-address-location-selector",
                                    onZipCodeChange: shippingCustomAddressZipCodeChanged,
                                    onCityChange: shippingCustomAddressCityChanged
                                }))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                        id: "shipping-address-custom-zip-input",
                                        placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_zip', 'Zip', 'checkout'),
                                        modelValue: __props.orderRequest.shippingCustomAddressZipCode,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.orderRequest.shippingCustomAddressZipCode) = $event)),
                                        "custom-class": "!w-[250px]",
                                        class: "flex-[0_0_100px] mr-3",
                                        type: "text",
                                        "max-length": zipCodeLength.value,
                                        border: "",
                                        "disable-focus-ring": "",
                                        required: "",
                                        "show-validity": true,
                                        valid: !(0, vue_2.unref)(validators_1.isBlank)(__props.orderRequest.shippingCustomAddressZipCode) && zipCharsValid.value,
                                        "allowed-chars": onlyNumeric.value ? '[0-9]' : '[a-zA-Z0-9][a-zA-Z0-9 -]',
                                        onValidate: handleZipValidation
                                    }, null, 8, ["placeholder", "modelValue", "max-length", "valid", "allowed-chars"]),
                                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                        id: "shipping-address-custom-city-input",
                                        placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_city', 'City', 'checkout'),
                                        modelValue: __props.orderRequest.shippingCustomAddressCity,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((__props.orderRequest.shippingCustomAddressCity) = $event)),
                                        class: "grow",
                                        type: "text",
                                        border: "",
                                        "disable-focus-ring": "",
                                        required: "",
                                        "show-validity": true,
                                        valid: !(0, vue_2.unref)(validators_1.isBlank)(__props.orderRequest.shippingCustomAddressCity)
                                    }, null, 8, ["placeholder", "modelValue", "valid"])
                                ])),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                id: "shipping-address-custom-street-input",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_street', 'Street', 'checkout'),
                                modelValue: __props.orderRequest.shippingCustomAddressStreet,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((__props.orderRequest.shippingCustomAddressStreet) = $event)),
                                class: "mb-3",
                                type: "text",
                                border: "",
                                "disable-focus-ring": "",
                                required: "",
                                "show-validity": true,
                                valid: !(0, vue_2.unref)(validators_1.isBlank)(__props.orderRequest.shippingCustomAddressStreet)
                            }, null, 8, ["placeholder", "modelValue", "valid"]),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                id: "shipping-address-custom-phone-input",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_phone', 'Phone', 'checkout'),
                                modelValue: __props.orderRequest.shippingCustomAddressPhone,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((__props.orderRequest.shippingCustomAddressPhone) = $event)),
                                class: "mb-3",
                                type: "text",
                                border: "",
                                "disable-focus-ring": "",
                                "show-validity": false,
                                valid: true
                            }, null, 8, ["placeholder", "modelValue"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                (0, vue_2.createElementVNode)("button", {
                                    id: "shipping-address-custom-address-submit-form-input",
                                    disabled: !(0, vue_2.unref)(customAddressFormValid),
                                    class: "btn btn-rounded btn-primary !inline-flex text-sm sm:text-base h-[63px] font-bold text-[20px] my-3",
                                    onClick: _cache[6] || (_cache[6] = ($event) => (submitCustomAddressForm()))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipping_address_custom_address_submit", "Next", "checkout")), 9, _hoisted_11)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (__props.orderRequest.shippingModeId ===
                        (0, vue_2.unref)(ShippingModeEnum_1.ShippingModeEnum).PERSONAL_AT_PICKUP_POINT)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SelectInput_vue_1.default, {
                            key: 4,
                            id: "shipping-address-pickup-point-select-input",
                            class: "mb-5",
                            "placeholder-enable": true,
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('pickup_point_placeholder', '-- Please select a pick-up point --', 'checkout'),
                            modelValue: __props.orderRequest.shippingPickupPointId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((__props.orderRequest.shippingPickupPointId) = $event)),
                            options: (0, vue_2.unref)(pickupPointAddressesOptions)
                        }, null, 8, ["placeholder", "modelValue", "options"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
